(function (global) {
  'use strict';
  const parseTime = (input, zone) => {
    const match = String(input || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!match || !['Asia/Shanghai', 'America/Los_Angeles', 'Europe/Berlin', 'UTC'].includes(zone)) return NaN;
    const [, y, m, d, h, min] = match.map(Number);
    const wall = Date.UTC(y, m - 1, d, h, min);
    const check = new Date(wall);
    if (y < 2000 || check.getUTCFullYear() !== y || check.getUTCMonth() !== m - 1 || check.getUTCDate() !== d || h > 23 || min > 59) return NaN;
    try {
      const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      const parts = time => Object.fromEntries(formatter.formatToParts(time).map(part => [part.type, part.value]));
      const offsets = new Set();
      for (let delta = -36; delta <= 36; delta += 6) {
        const sample = wall + delta * 3600000;
        const p = parts(sample);
        offsets.add(Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute) - sample);
      }
      const matches = [...offsets].map(offset => wall - offset).filter(time => {
        const p = parts(time);
        return +p.year === y && +p.month === m && +p.day === d && +p.hour === h && +p.minute === min;
      });
      return matches.length === 1 ? matches[0] : NaN;
    } catch { return NaN; }
  };
  const prepare = row => ({ ...row, startMs: parseTime(row.start, row.zone), endMs: parseTime(row.end, row.zone) });
  const active = (row, now, productId, variantId, market) => Boolean(row && !row.invalid && row.enabled === true && String(row.productId) === String(productId) && String(row.variantId) === String(variantId) && row.market === market && Number.isFinite(row.startMs) && Number.isFinite(row.endMs) && row.endMs > row.startMs && now >= row.startMs && now < row.endMs);
  const unitFormatters = new Map();
  const remaining = (ms, locale = 'en') => {
    const seconds = Math.max(ms > 0 ? 1 : 0, Math.floor(ms / 1000));
    const units = ms >= 86400000
      ? [['day', Math.floor(seconds / 86400)]]
      : ms >= 3600000
        ? [['hour', Math.floor(seconds / 3600)], ['minute', Math.floor(seconds / 60) % 60]]
        : [['minute', Math.floor(seconds / 60)], ['second', seconds % 60]];
    return units.map(([unit, value]) => {
      const key = `${locale}:${unit}`;
      if (!unitFormatters.has(key)) unitFormatters.set(key, new Intl.NumberFormat(locale, { style: 'unit', unit, unitDisplay: 'long' }));
      return unitFormatters.get(key).format(value);
    }).join(' ');
  };
  const api = { parseTime, prepare, active, remaining };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document || global.EooqiAmazonDeals) return;
  global.EooqiAmazonDeals = api;
  const document = global.document;
  let rows = new Map();
  let badges = [];
  let timer;
  let invalidConfig = false;
  const read = () => {
    rows = new Map();
    invalidConfig = false;
    document.querySelectorAll('[data-eooqi-deal-config]').forEach(node => {
      try {
        const config = JSON.parse(node.textContent);
        if (!Array.isArray(config)) throw new Error('invalid_config');
        config.forEach(row => {
          const key = `${row.productId}:${row.variantId}:${row.market}`;
          rows.set(key, rows.has(key) ? { invalid: true } : prepare(row));
        });
      } catch { invalidConfig = true; }
    });
    badges = [...document.querySelectorAll('[data-eooqi-deal-badge]')];
    global.clearInterval(timer);
    if (badges.length) timer = global.setInterval(render, 1000);
    render();
  };
  const render = () => {
    const detectedMarket = global.EooqiAmazonLinks?.getMarket();
    const now = Date.now();
    badges.forEach(badge => {
      const product = badge.closest('eooqi-market-product, eooqi-pet-product, eooqi-catalog-product, eooqi-reptile-product');
      const market = product?.dataset.poolMarket || detectedMarket;
      const productId = badge.dataset.productId;
      const variantId = badge.dataset.variantId || product?.dataset.selected;
      const row = rows.get(`${productId}:${variantId}:${market}`);
      const link = product && [...product.querySelectorAll('a[data-eooqi-amazon]')].find(item => item.dataset.variantId === variantId && item.dataset.productId === productId && item.dataset.market === market && item.hasAttribute('href') && !item.hasAttribute('data-eooqi-link-error') && item.getAttribute('aria-disabled') !== 'true');
      const visible = !invalidConfig && Boolean(link) && active(row, now, productId, variantId, market);
      const memberVisible = Boolean(link) && market === 'US' && !visible;
      badge.hidden = !(visible || memberVisible);
      badge.querySelector('[data-deal-promotion]').hidden = !visible;
      badge.querySelector('[data-member-offer]').hidden = !memberVisible;
      if (visible) {
        const countdown = badge.querySelector('[data-deal-countdown]');
        const text = remaining(row.endMs - now, document.documentElement.lang || 'en');
        if (countdown.textContent !== text) countdown.textContent = text;
        badge.querySelector('[data-deal-end]').dateTime = new Date(row.endMs).toISOString();
      }
    });
  };
  document.addEventListener('eooqi:market-change', render);
  document.addEventListener('eooqi:variant-change', render);
  document.addEventListener('shopify:section:load', read);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(read));
  document.addEventListener('visibilitychange', render);
  global.addEventListener('pageshow', render);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', read, { once: true });
  else read();
})(typeof window !== 'undefined' ? window : globalThis);

